import React from "react";
import styled from "styled-components";
import Project from "./Project";
import PROJECTS_DATA from "./DATA";
import github from "../assets/github.svg";

const Projects = () => {
  return (
    <ProjectsSection>
      <h2 id="projects">Projects </h2>
      {PROJECTS_DATA.map((dataItem) => {
        return <Project project={dataItem} key={dataItem.id} />;
      })}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <div className="container">
          <p>To check my other projects go to my github page:</p>
          <a
            href="https://github.com/cataraul"
            target="_blank"
            className="link-github"
          >
            <button>
              <img src={github} alt="github icon" />
              Github
            </button>
          </a>
        </div>
      </div>
    </ProjectsSection>
  );
};

export default Projects;

const ProjectsSection = styled.section`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: column;
  color: #1f2858;

  .link-github {
    text-decoration: none;
    margin: 1rem 0;
    button {
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 1rem;
      padding: 1rem 3rem;
      background-color: #2a52be;
      border: 1px solid #2a52be;
      border-radius: 0.4rem;
      color: #fefefe;
      transition: all 0.3s ease;
      cursor: pointer;
      font-size: 1.2rem;
      margin: 0 1rem;
      &:hover {
        color: #2a52be;
        background-color: #fefefe;
        border: 1px solid #2a52be;
      }
      img {
        padding: 0 0.3rem;
      }
    }
  }
  .container {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    text-align: center;
  }
`;
